import PropTypes from "prop-types";
import React from "react";

function ItemCount(props) {
  const { fieldVal } = props;

  if (Array.isArray(fieldVal) && fieldVal.length !== 0) {
    return (
      <span className="badge item-count">{`${fieldVal.length} items`}</span>
    );
  } else if (
    typeof fieldVal === "object" &&
    Object.keys(fieldVal).length !== 0
  ) {
    return (
      <span className="badge item-count">{`${
        Object.keys(fieldVal).length
      } items`}</span>
    );
  }
  return null;
}

ItemCount.propTypes = {
  fieldVal: PropTypes.any.isRequired,
};

export { ItemCount };
